import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Card, Button } from "react-bootstrap";
import { Popover } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { OPEN_LOGIN_POPUP } from "../store/user/types";

//sweet alert
import swal from "sweetalert";

//jquery
import $ from "jquery";

const CardPricing = ({ price, about, title, image }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const about_temp = [];
  about_temp.push(about[1]);
  about_temp.push(about[2]);

  const userType = localStorage.getItem("type");
  const isAuth = localStorage.getItem("isAuth");

  const handleClick = (scheduleTitle) => {
    localStorage.setItem("ScheduleTitle", scheduleTitle);
    !isAuth
      ? dispatch({ type: OPEN_LOGIN_POPUP })
      : userType === "interviewee"
        ? history.push("/schedule")
        : swal({
          title: "Oops!",
          text: "You are not Interviewee!",
          icon: "info",
        });
  };
  return (
    <Col sm={4} className="mb-5 px-5">
      <Card className="shadow-lg">
        <Card.Body className="p-0">
          <Card.Text
            className="float-left position-relative ml-2 py-1 px-3 rounded bg-info text-white font-weight-bold"
            style={{ letterSpacing: 2, fontSize: 12 }}
          >
            POPULAR
          </Card.Text>
          <Popover
            placement="right"
            title={about[0]}
            content={about.map((item) => (
              <li>{item}</li>
            ))}
            trigger="hover"
          >
            <i
              className="fas fa-info-circle float-right position-relative px-2 fa-lg text-white"
              style={{ cursor: "pointer" }}
            ></i>
          </Popover>
          <Card.Img variant="top" src={image} style={{ marginTop: "-50px" }} />
          {/* <Scrollbars style={{height: 160}}> */}
          <Card.Title
            className="text-left px-3 pt-4 font-weight-bold scheduleType"
            style={{ fontSize: 15 }}
          >
            {title}
          </Card.Title>
          <Card.Title
            className="text-left px-3 font-weight-bold"
            style={{ fontSize: 17 }}
          >
            Price : ${price}
          </Card.Title>
          <Button variant="primary" className="my-3" onClick={() => handleClick(title)}>
            Schedule
          </Button>

          {/* <Card.Text className="p-3">
            <ul class="list-group list-group-flush">
              {about_temp.map((item) => (
                <li class="list-group-item">{item}</li>
              ))}
            </ul>
          </Card.Text> */}
          {/* </Scrollbars> */}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default CardPricing;
